// ============================================================
// Firebase init for the TrueNooch marketing site
// ============================================================
// Config is fetched from /__/firebase/init.json — served dynamically
// by Firebase Hosting so we don't hardcode the web config or check
// any keys into source control.
//
// Firestore only. Auth was dropped on 2026-08-30 with the
// auth-gated routes; the real boundary is firestore.rules.
// ============================================================

import { initializeApp, FirebaseApp } from 'firebase/app';
import { getFirestore, Firestore } from 'firebase/firestore';

export interface FirebaseInstances {
  app: FirebaseApp;
  db: Firestore;
}

let instances: FirebaseInstances | null = null;
let initPromise: Promise<FirebaseInstances> | null = null;

export function initFirebase(): Promise<FirebaseInstances> {
  if (instances) return Promise.resolve(instances);
  if (initPromise) return initPromise;

  initPromise = (async () => {
    const response = await fetch('/__/firebase/init.json');
    if (!response.ok) {
      throw new Error(`Failed to load Firebase config: ${response.status}`);
    }
    const config = await response.json();
    const app = initializeApp(config);
    const db = getFirestore(app);
    instances = { app, db };
    return instances;
  })();

  return initPromise;
}
